import React, {useState} from "react";
import {
    DiscreteColorLegend,
    FlexibleWidthXYPlot,
    Hint,
    HorizontalGridLines,
    RadialChart,
    VerticalBarSeries,
    VerticalGridLines,
    XAxis,
    YAxis
} from "react-vis";
import {Divider, Grid, Header} from 'semantic-ui-react'
import CostCentersTable from "./CostCentersTable";
import {useNavigate} from "react-router";

require('../../../node_modules/react-vis/dist/style.css')


export default function CostCenters(props) {

    const [data, setData] = useState({
        costcenters: [{
            cost_center: '',
            balance_total: 0,
            avg: 0,
            chartdata: [{x: 0, y: 0}],
        }],
        radialchartdata: [{angle: 0, label: ''}],
        legend_items: [],
        value: false,
        loading: true
    });

    const navigate = useNavigate()

    const fetchData = async () => {
        try {
            const year = props.year;
            const url = API_URL + `/api/private/tanker/v1/costcenters/${year}`

            const token = sessionStorage.token
            if (!(token && token.length > 0)) navigate('/login')

            fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
                .then(function (response) {
                    if (response.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    return response.json();
                })
                .then(function (data) {
                    let costcenters = []
                    let legend_items = []
                    let radialchartdata = []

                    for (var c of data) {
                        let chartdata = []
                        c.months.forEach(function (value, index) {
                            chartdata.push({x: value.month, y: value.balance})
                        })
                        costcenters.push({
                            cost_center: c.cost_center,
                            balance_total: c.balance_total,
                            avg: c.avg,
                            chartdata: chartdata
                        })
                        legend_items.push(c.cost_center)
                        radialchartdata.push({angle: c.avg, label: c.cost_center})
                    }
                    setData({
                        costcenters: costcenters,
                        radialchartdata: radialchartdata,
                        legend_items: legend_items,
                        loading: false
                    });
                });
        } catch (error) {
            console.log(error)
        }
    }


    const {year} = props
    const {legend_items, value, radialchartdata} = data
    let costcenters = data.costcenters
    // calculate min max of yDomain forEach cost center
    let yDomain = {min: 0, max: 0}
    let y
    costcenters.forEach((cost_center) => {
            y = cost_center.chartdata.reduce((res, row) => {
                    return {
                        max: Math.max(res.max, row.y),
                        min: Math.min(res.min, row.y)
                    };
                },
                {max: -Infinity, min: Infinity}
            )
            if (yDomain.min > y.min) {
                yDomain.min = y.min
            }
            if (yDomain.max < y.max) {
                yDomain.max = y.max
            }
            //difference bar chart
            let cdata = cost_center.chartdata.map((x, idx) => ({
                x: parseInt(x.x),
                // if the bars are above zero then we start them at zero
                y0: (parseFloat(x.y) > 0) ? 0 : 0 + parseFloat(x.y),
                // if the bars are below zero then we stop them at zero
                y: (parseFloat(x.y) < 0) ? 0 : parseFloat(x.y)
            }));
            cost_center.chartdata = cdata
        }
    )

    return (
        <div style={{marginTop: '2em'}}>
            <Header>Balance pro Kostenstelle {year}</Header>
            <p>Hinweis: Operating Costs sind hier nicht abgezogen.</p>
            <Grid>
                <Grid.Row>
                    <Grid.Column width={12}>
                        <DiscreteColorLegend orientation="horizontal" items={legend_items}/>
                        <FlexibleWidthXYPlot
                            height={300}
                            margin={{left: 100}}
                            colorType="category"
                            xType="ordinal"
                            yDomain={[yDomain.min, yDomain.max]}
                        >
                            <VerticalGridLines/>
                            <HorizontalGridLines/>
                            <XAxis/>
                            <YAxis/>

                            {value !== false && <Hint value={value}/>}
                            {costcenters.length > 0 && costcenters.map((cost_center) => (
                                    <VerticalBarSeries
                                        data={cost_center.chartdata}
                                        key={cost_center.cost_center}
                                        onValueMouseOver={v => this.setState({value: v})}
                                        onSeriesMouseOut={v => this.setState({value: false})}
                                    >
                                    </VerticalBarSeries>
                                )
                            )}
                        </FlexibleWidthXYPlot>
                    </Grid.Column>
                    <Grid.Column>
                        <RadialChart colorType="category" data={radialchartdata} width={300} height={300}
                                     showLabels/>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Divider/>
            <CostCentersTable costcenters={costcenters}/>
        </div>
    )
}